var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 38V14m0 24h4m-4 0H18m10-24a8 8 0 0 0-8-8h-8a8 8 0 0 0-8 8v16a8.003 8.003 0 0 0 6.008 7.75M28 14h6.418a4 4 0 0 1 2.736 1.082l5.582 5.233A4 4 0 0 1 44 23.233V34a4 4 0 0 1-4 4m0 0a4 4 0 0 1-8 0m8 0a4 4 0 0 0-8 0m-14 0a4 4 0 1 1-7.992-.25M18 38a4 4 0 0 0-7.992-.25",
    stroke: "#141718",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 16h-4m4 8h-8",
    stroke: "#141718",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrack);
export default __webpack_public_path__ + "static/media/track.88f2f773391ccee3f82f8cfd530dcc48.svg";
export { ForwardRef as ReactComponent };